import HeroImg from "../assets/images/hero.jpg";
import AuthForm from "../features/auth/AuthForm";

const Login = () => {
  return (
    <AuthForm
      type="login"
      title="Welcome"
      subtitle="Login with your mobile number to continue"
      image={HeroImg}
      footerText="Don't have an account?"
      footerLink="Sign Up"
      footerPath="/sign-up"
    />
  );
};

export default Login;
